export { default as OperationManagementView } from './OperationManagementView';
